import React from "react";

import "./VisualShowcase.scss";

interface VisualShowcaseProps {
  title?: string;
  description?: string;
  imageUrl: string;
  imageAlt: string;
  layout?: "full" | "centered" | "split";
  titleColor?: string;
  descriptionColor?: string;
  backgroundColor?: string;
}

export function VisualShowcase({
  title,
  imageAlt,
  imageUrl,
  backgroundColor,
  titleColor,
  descriptionColor,
  description,
  layout,
}: VisualShowcaseProps) {
  const layoutClass = layout === "centered" ? "layoutCentered" : "layoutFull";

  return (
    <section className="visualShowcase" style={{ backgroundColor }}>
      <div className="showcaseContainer">
        {(title || description) && (
          <div className="showcaseHeader">
            {title && (
              <h2 className="showcaseTitle" style={{ color: titleColor }}>
                {title}
              </h2>
            )}
            {description && (
              <p
                className="showcaseDescription"
                style={{ color: descriptionColor }}
              >
                {description}
              </p>
            )}
          </div>
        )}
        <div className={`showcaseImageWrapper ${layoutClass}`}>
          <div className="showcaseImageContainer">
            <img src={imageUrl} alt={imageAlt} className="showcaseImage" />
          </div>
        </div>
      </div>
    </section>
  );
}
